import React from 'react';
import bathroom from '../images/bathroom_3.png';

const headerStyles = {
  header: {
    position: 'relative',
    height: '60vh',
    width: '100%',
    color: '#FFFFFF',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center'
  },
  backgroundImage: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: -1
  },
  overlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(44, 62, 80, 0.7)', // Dark blue overlay
    zIndex: -1
  },
  content: {
    padding: '1.5rem',
    maxWidth: '800px'
  },
  title: {
    fontSize: '4.5rem',
    marginBottom: 0,
    textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
  },
  location: {
    fontSize: '2.5rem',
    color: '#3498DB',
    marginTop: '-0.5rem',
    marginBottom: '1rem',
    textShadow: '2px 2px 4px rgba(0,0,0,0.3)'
  },
  tagline: {
    fontSize: '1.2rem',
    marginBottom: '1.5rem',
    opacity: '0.9'
  },
  button: {
    backgroundColor: '#3498DB',
    color: '#FFFFFF',
    padding: '0.8rem 1.6rem',
    fontSize: '1rem',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    textDecoration: 'none',
    display: 'inline-block',
    transition: 'background-color 0.3s ease',
    ':hover': {
      backgroundColor: '#2980B9'
    }
  }
};

const Header = () => {
  return (
    <header style={headerStyles.header}>
      <img
        src={bathroom}
        alt="Luxury bathroom interior"
        style={headerStyles.backgroundImage}
      />
      <div style={headerStyles.overlay}></div>
      <div style={headerStyles.content}>
        <h1 style={headerStyles.title}>Fix it All</h1>
        <h2 style={headerStyles.location}>Scotland</h2>
        <p style={headerStyles.tagline}>Professional Property Services</p>
        <a
          href="mailto:info@fix-it-all-scotland.com"
          style={headerStyles.button}
        >
          Contact Us Today
        </a>
      </div>
    </header>
  );
};

export default Header;
